import axios from "axios";
import ReferralMerchantFeeDTO from "@/models/ReferralMerchantFeeDTO";

export const referrals = {
    merchants: async (referralId?: number): Promise<ReferralMerchantFeeDTO[]> => {
        let resp = await axios({
            url: `/referrals/merchants`,
            method: 'GET',
            params: referralId ? {referralId} : {},
        });

        return resp.data as ReferralMerchantFeeDTO[]
    },
}
